import { render } from "./DynamicHtmlH1.vue?vue&type=template&id=0a4bfecb&ts=true"
import script from "./DynamicHtmlH1.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlH1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlH1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a4bfecb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a4bfecb', __exports__)) {
    api.reload('0a4bfecb', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlH1.vue?vue&type=template&id=0a4bfecb&ts=true", () => {
    api.rerender('0a4bfecb', render)
  })

}


export default __exports__